import { getAnalytics } from "@tm/insurance/analytics";
import { TextNodeType } from "@tm/ui-widgets/components";
import FormattedText from "../FormattedText/FormattedText";
import { ButtonContainer } from "./LandingButtonComp.styles";

type ButtonProps = {
  buyButton: {
    prefix?: TextNodeType;
    suffix?: TextNodeType;
  };
  onPayment?: () => void;
  isLoading?: boolean;
};

const LandingButtonComp = ({
  buyButton,
  onPayment,
  isLoading,
}: ButtonProps) => {
  const analytics = getAnalytics();
  const { prefix, suffix } = buyButton;

  const handleBuyClick = () => {
    analytics?.trackTravDetailsEvents({
      actionType: "buy_clicked",
    });
    if (isLoading) {
      return;
    }
    if (onPayment) {
      onPayment();
    }
  };

  return (
    <ButtonContainer
      onClick={handleBuyClick}
      data-test-id="LandingButtonComp-ButtonContainer"
      style={{
        cursor: isLoading ? "not-allowed" : "pointer",
        opacity: isLoading ? 0.6 : 1,
      }}
    >
      {prefix && <FormattedText value={prefix} />}
      {suffix && <FormattedText value={suffix} />}
    </ButtonContainer>
  );
};

export default LandingButtonComp;
